module.exports = __webpack_public_path__ + "img/pr-10.46bb6d2a.png";